import { UvRouteHeader } from '@/lib/router';

const header: UvRouteHeader = {
  route: 'admin.users.index',
  label: ({ user }) => (user ? `Vizualizare utilizator "${user}"` : 'Vizualizare utilizator'),
  menu: (route) => [
    {
      route: {
        name: 'admin.users.edit.roles',
        params: route.params,
      },
      icon: 'edit',
      label: 'Roluri',
    },
    {
      route: {
        name: 'admin.users.institution',
        params: route.params,
      },
      icon: 'edit',
      label: 'Institutie',
    },
    { isDivider: true },
    {
      route: {
        name: 'admin.users.edit.email',
        params: route.params,
      },
      icon: 'email',
      label: 'Modifica e-mail',
    },
    {
      route: {
        name: 'admin.users.edit.password',
        params: route.params,
      },
      icon: 'lock',
      label: 'Modifica parola',
    },
    {
      route: {
        name: 'admin.users.edit.name',
        params: route.params,
      },
      icon: 'edit',
      label: 'Modifica nume',
    },
  ],
};

export default header;
